<div class="qty-stepper" dir="ltr">
  <button type="button" (click)="bump(-1)" [disabled]="!canDecrease"
    [attr.aria-label]="'הקטנת כמות עבור ' + label">
    −
  </button>
  @if (soldByWeight) {
  <label class="kg-field" dir="ltr" [class.is-estimating]="estimating">
    @if (estimating) {
    <span class="kg-status" role="status"><span>מחשב</span><span>…</span></span>
    } @else {
    <span>ק״ג</span>
    <input type="text" inputmode="decimal" autocomplete="off" [attr.data-testid]="testId"
      [disabled]="controlsLocked" [ngModel]="draft" (ngModelChange)="draft = $event"
      (focus)="onDraftFocus()" (blur)="commitDraft()"
      (keydown.enter)="$event.preventDefault(); commitDraft()"
      [attr.aria-label]="'משקל בקילוגרם עבור ' + label" />
    }
  </label>
  } @else {
  <span [attr.data-testid]="testId">{{ shownQuantity() }}</span>
  }
  <button type="button" (click)="bump(1)" [disabled]="!canIncrease"
    [attr.aria-label]="'הגדלת כמות עבור ' + label">
    +
  </button>
  @if (soldByWeight) {
  <button type="button" class="kg-camera" (click)="openCamera()" [disabled]="controlsLocked"
    [attr.aria-label]="'צילום שקית עבור ' + label">
    <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2"
      stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">
      <path d="M4 8h3l2-2h6l2 2h3v11H4z" />
      <circle cx="12" cy="13" r="3.2" />
    </svg>
  </button>
  }
</div>

@if (cameraOpen) {
<div class="bag-overlay" appBodyPortal role="dialog" aria-modal="true" aria-labelledby="bag-photo-title">
  <div class="bag-sheet">
    <div class="bag-sheet-header">
      <h3 id="bag-photo-title">צילום שקית</h3>
      <button type="button" class="bag-close" (click)="closeCamera()">סגור</button>
    </div>
    <p class="bag-hint">צלמו את השקית. ההערכה תיכנס למשקל, ואפשר לתקן אותה אחרי השקילה.</p>
    @if (cameraError) {
    <p class="bag-error" role="alert">{{ cameraError }}</p>
    } @else {
    <video #cameraVideo class="bag-video" playsinline muted autoplay></video>
    <button type="button" class="bag-capture" (click)="capture()">צילום</button>
    }
  </div>
</div>
}
